import cx from 'classnames'
import { Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, Input, FormFeedback } from 'reactstrap';

import { usePropertySearchQuery } from 'hooks/usePropertySearchQuery'
import { PropertyCard } from 'components/Property'

import { useState, ComponentType } from 'react'

const REQUEST_ERROR_MESSAGE = "Asegúrate de estar conectado a internet y de estar buscando propiedades sólo por su id.";
const EMPTY_FIELD_ERROR_MESSAGE = "Este campo no puede ser vacío.";
const SEARCHING_MESSAGE = "Buscando..."

export const SearchPropertyModal = () => {

  const [propertyId, setPropertyId] = useState("");
  const [searchText, setSearchText] = useState("");


  const search = () => {
    const result = findProperty({
      variables: { uuid: propertyId },
    })
  }

  const [findProperty, { loading, error, data }] = usePropertySearchQuery()

  let property;
  if (data) {
    if (data.property != null) {
      property = <div key={data.property.uuid} className="py-10">
        <PropertyCard property={data.property} />
      </div>;
    } else {
      property = <div>No se encontraron coincidencias</div>
    }
  }

  if (error) {
    console.log("Error >>>>")
    console.log(error)
  }


  return (
    <Container>
      <InputGroup>
        <Input
          value={propertyId}
          className={cx('border-1', 'font-weight-500', 'bg-athens-gray', 'no-outline')}
          onChange={(e) => setPropertyId(e.target.value)}
          onBlur={(e) => setPropertyId(e.target.value)}
          type="number"
        />
        <InputGroupAddon addonType="append"><Button color="primary" onClick={search} >Buscar</Button></InputGroupAddon>
        <FormFeedback>{error ? REQUEST_ERROR_MESSAGE : EMPTY_FIELD_ERROR_MESSAGE}</FormFeedback>
      </InputGroup>
      {loading ? SEARCHING_MESSAGE : ""}
      <Row xs="1" sm="3" md="4" lg="5">
        {property}
      </Row>
    </Container>
  )

}